export enum FlagCode {
  clinical = 'flag.code.clinical',
}
